import { Link } from "react-router-dom";
import { Gauge, Fuel, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getImageUrl } from "@/utils/imageUrl";

const CarCard = ({ car }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
    }).format(price);
  };

  const formatKm = (km) => {
    return new Intl.NumberFormat('fr-FR').format(km);
  };

  return (
    <div 
      className="car-card group"
      data-testid={`car-card-${car.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={getImageUrl(car.images?.[0]) || "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800"}
          alt={`${car.marque} ${car.modele}`}
          className="car-image w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        
        {/* Badge */}
        <div className="absolute top-4 right-4">
          {car.disponible ? (
            <span className="badge-disponible">Disponible</span>
          ) : (
            <span className="badge-vendu">Vendu</span>
          )}
        </div>

        {/* Price overlay */}
        <div className="absolute bottom-4 left-4">
          <span className="text-yellow-400 font-bold text-2xl">
            {formatPrice(car.prix)}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-1">
          {car.marque} {car.modele}
        </h3>
        <p className="text-gray-500 text-sm mb-4">{car.annee}</p>

        {/* Specs */}
        <div className="flex items-center gap-4 text-sm text-gray-500 mb-6">
          <div className="flex items-center gap-1.5">
            <Gauge className="w-4 h-4 text-yellow-500" />
            <span>{formatKm(car.kilometrage)} km</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Fuel className="w-4 h-4 text-yellow-500" />
            <span>{car.carburant}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Settings2 className="w-4 h-4 text-yellow-500" />
            <span>{car.transmission}</span>
          </div>
        </div>

        {/* CTA */}
        <Link to={`/voitures/${car.id}`}>
          <Button 
            className="w-full bg-gray-100 hover:bg-yellow-500 hover:text-white text-gray-800 transition-all duration-300"
            data-testid={`view-car-${car.id}`}
          >
            Voir le véhicule
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CarCard;
